import React from "react";
import { Link } from "react-router-dom";
import Seo from "./Seo";

const NotFound = () => (
  <main className="not-found-state">
    <Seo title="Page not found" />
    <span>404</span>
    <h1>This page isn't on the menu</h1>
    <p>Let's get you back to something delicious.</p>
    <Link className="button button--primary" to="/shop">Browse the market</Link>
  </main>
);

export default NotFound;
